import styled from 'styled-components'

import InfoTooltip from '@/app/components/InfoToolTip'
import { IColumn } from '@/app/components/Table/types'
import { colors } from '@/config/global-parameters'

import elecciones, { Eleccion } from '../../types/elecciones'
import VoteCell from './VoteCell'

const getTableColumns = () => {
  const tableColumns: IColumn[] = [
    {
      align: 'flex-start',
      canSort: false,
      dataIndex: 'election',
      key: 'election',
      render: ({ eleccion }: { eleccion: Eleccion }) => (
        <ElectionText>{elecciones[eleccion].label}</ElectionText>
      ),
      title: 'ELECCIONES',
      width: 'max-content',
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'UPCh',
      key: 'UPCh',
      render: ({ resultados }) => (
        <VoteCell
          circumscriptionVotes={1}
          list="3"
          listVotes={resultados[3]}
        />
      ),
      title: (
        <>
          UNIDAD
          <br />
          PARA CHILE
          <InfoTooltip
            color={colors.colorBlack}
            id="unidad-para-chile-tooltip"
            message="PS, PC, RD, CS, FRVS, PL, COM, AH."
          />
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'TPCh',
      key: 'TPCh',
      render: ({ resultados }) => (
        <VoteCell
          circumscriptionVotes={1}
          list="1"
          listVotes={resultados[1]}
        />
      ),
      title: (
        <>
          TODO
          <br />
          POR CHILE
          <InfoTooltip
            color={colors.colorBlack}
            id="todo-por-chile-tooltip"
            message="PPD, DC, PR."
          />
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'PDG',
      key: 'PDG',
      render: ({ eleccion, resultados }) => {
        if (eleccion === '2021_c')
          return <ListText style={{ color: colors.colorGrey12 }}>--</ListText>

        return (
          <VoteCell
            circumscriptionVotes={1}
            list="0"
            listVotes={resultados[0]}
          />
        )
      },
      title: (
        <>
          PARTIDO DE
          <br />
          LA GENTE
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'ChS',
      key: 'ChS',
      render: ({ resultados }) => (
        <VoteCell
          circumscriptionVotes={1}
          list="4"
          listVotes={resultados[4]}
        />
      ),
      title: (
        <>
          CHILE
          <br />
          SEGURO
          <InfoTooltip
            color={colors.colorBlack}
            id="chile-seguro-tooltip"
            message="RN, UDI, EVO."
          />
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'REP',
      key: 'REP',
      render: ({ eleccion, resultados }) => {
        if (eleccion === '2021_c')
          return <ListText style={{ color: colors.colorGrey12 }}>--</ListText>

        return (
          <VoteCell
            circumscriptionVotes={1}
            list="2"
            listVotes={resultados[2]}
          />
        )
      },
      title: (
        <>
          PARTIDO
          <br />
          REPUBLICANO
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'LP',
      key: 'LP',
      render: ({ eleccion, resultados }) => {
        if (eleccion === '2021_c') {
          return (
            <VoteCell
              circumscriptionVotes={1}
              list="7"
              listVotes={resultados[7]}
            />
          )
        }
        return <ListText style={{ color: colors.colorGrey12 }}>--</ListText>
      },
      title: (
        <>
          LISTA
          <br />
          DEL PUEBLO
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'NC',
      key: 'NC',
      render: ({ eleccion, resultados }) => {
        if (eleccion === '2021_c') {
          return (
            <VoteCell
              circumscriptionVotes={1}
              list="8"
              listVotes={resultados[8]}
            />
          )
        }
        return <ListText style={{ color: colors.colorGrey12 }}>--</ListText>
      },
      title: (
        <>
          NUEVA
          <br />
          CONSTITUCIÓN
        </>
      ),
    },
    {
      align: 'center',
      canSort: false,
      dataIndex: 'OTROS',
      key: 'OTROS',
      render: ({ eleccion, resultados }) => {
        if (eleccion === '2021_c' || eleccion === '2023_c' || eleccion === '2021_d') {
          return (
            <VoteCell
              circumscriptionVotes={1}
              list="10"
              listVotes={resultados[10]}
            />
          )
        }
        return <ListText style={{ color: colors.colorGrey12 }}>--</ListText>
      },
      title: <>OTROS</>,
    },
  ]
  return tableColumns
}

const ElectionText = styled.div`
  font-size: 13px;
`

const ListText = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`

export default getTableColumns
